// extracted by mini-css-extract-plugin
module.exports = {"alert":"Notification-styles_alert__1f7L2"};